@if (auth.error$ | async) {
<div class="auth-error">
  <h1>Authentication Error</h1>
  <div>{{ (auth.error$ | async)?.name }}</div>
  <div>{{ (auth.error$ | async)?.message }}</div>
  <button
    mat-stroked-button
    (click)="login()"
    type="button"
  >
    Login Again
  </button>
</div>
}
